import Experience from "../Experience";
import * as THREE from "three";
import Resources from "../Utils/Resources";

export default class World {
  experience!: Experience;
  scene!: THREE.Scene;
  resources!: Resources;

  constructor() {
    this.experience = new Experience();
    this.scene = this.experience.scene;
    this.resources = this.experience.resources;

    this.resources.on("ready", () => {
      // setup hook
    });
  }

  update(): void {}
}
